<div class="w-full">
  <!-- Zone de drop / upload -->
  <label
    class="flex flex-col items-center justify-center w-full h-48 border-2 border-dashed border-blue-300 rounded-lg cursor-pointer bg-blue-50 hover:bg-blue-100 transition">
    <input
      type="file"
      (change)="onFileAdded($event)"
      class="hidden"
      multiple
      accept="image/*,.pdf,.doc,.docx"
      [disabled]="maxFiles<files.length" />

      <div class="flex flex-col items-center text-blue-400">
        <div class="flex space-x-6 text-5xl mb-3">
          <i class="fa-solid fa-cloud-arrow-up"></i>
          <i class="fa-solid fa-camera"></i>
        </div>

        <span class="text-center font-semibold">
          {{ 'vues.uploadDocument.uploadClick' | translate }}
        </span>
      </div>
    </label>

    <!-- Liste des documents -->
    @if (files.length > 0) {
      <div class="mt-6">
        <h3 class="font-semibold text-gray-600 mb-3">
          {{ 'vues.uploadDocument.documentsPendingUpload' | translate }}
        </h3>
        @for (file of files; track file; let i = $index) {
          <div
            class="flex items-center bg-white shadow-sm border rounded-lg p-3 mb-3">
            <!-- Badge type fichier -->
            <span
              class="px-3 py-1 rounded text-white font-bold mr-4"
              [ngClass]="getBadgeColor(file.name)">
              {{ getFileExtension(file.name) | uppercase }}
            </span>
            <!-- Nom du fichier -->
            <span class="truncate text-sm flex-1">
              {{ file.name }}
            </span>
            <!-- Bouton supprimer -->
            <button
              class="ml-4 text-red-500 hover:text-red-700"
              (click)="removeFile(i)">
              <i class="fa-solid fa-circle-xmark text-xl"></i>
            </button>
          </div>
        }
      </div>
    }
  </div>